<template>
  <div class="menu-container">
    <el-menu mode="horizontal" :default-active="defaultActive">
      <el-menu-item v-for="menu in menus" :key="menu.name" :index="menu.to.name">
        <router-link :to="{ ...menu.to, query: $route.query }">
          <span>{{ menu.name }}</span>
        </router-link>
      </el-menu-item>
    </el-menu>
    <br />
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CustomerStructuresMenu extends Vue {
  get menus() {
    const isFrontend = this.$route.name.startsWith('frontend');

    return [
      {
        name: '业务员部门数据统计',
        to: { name: [isFrontend ? 'frontend' : '', 'reports/customer_structures.ranked_users'].filter(Boolean).join('.') }
      },
      {
        name: '关键行为数据',
        to: { name: [isFrontend ? 'frontend' : '', 'reports/customer_structures.key_behaviors'].filter(Boolean).join('.') }
      },
      {
        name: '客户/销售数据统计',
        to: { name: [isFrontend ? 'frontend' : '', 'reports/customer_structures'].filter(Boolean).join('.') }
      }
    ]
  }

  get defaultActive() {
    return this.$route.name;
  }
}
</script>

<style lang="scss" scoped>
.menu-container {
  position: sticky;
  top: 0;
  z-index: 100;
}

.el-menu--horizontal {
  .el-menu-item {
    padding-left: 0;
    padding-right: 0;
    height: 40px;
    line-height: 40px;
  }
}

a {
  width: 100%;
  height: 100%;
  display: block;
  padding-inline: 20px;
}
</style>
